import { helper } from '@ember/component/helper';
import moment from 'moment-timezone';

// Formati validi pre-definiti per performance
const VALID_FORMATS = ['DD/MM/YYYY', 'YYYY', 'YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ssZ', moment.ISO_8601];

/**
 * Calcola la differenza in anni tra due date
 */
function dateDiffYear([inputDate, referenceDate]) {
  if (!inputDate) return undefined;
  const parsedInputDate = moment(inputDate, VALID_FORMATS, true);
  if (!parsedInputDate.isValid()) return undefined;

  // Wrappa in moment() per supportare stringhe, Date e oggetti Moment
  const refDate = referenceDate ? moment(referenceDate) : moment();
  if (!refDate.isValid()) return undefined;

  // diff(..., 'years') è calendar-aware (età corretta al compleanno).
  // duration().asYears() usa la media 365.25gg e arrotonda per difetto al
  // confine esatto dell'anno → età off-by-one.
  return refDate.diff(parsedInputDate, 'years');
}
var dateDiffYear$1 = helper(dateDiffYear);

export { dateDiffYear, dateDiffYear$1 as default };
//# sourceMappingURL=date-diff-year.js.map
